import './styles/DateTimePicker.scss';
import { IonDate, IonDateString, IonDateFormat, IsIonDateFormat } from './IonDate.tsx';
import React, { useState, useEffect, useRef, ReactElement } from 'react';
import SelectionBox from './SelectionBox.tsx';
//import { Country } from 'country-state-city';

//classes
import SelectionList from '../i-classes/selectionList';

//mui
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const nonstate = {
    hoursSelectionList: [
        { key: '01', value: '01' } as SelectionList,
        { key: '02', value: '02' } as SelectionList,
        { key: '03', value: '03' } as SelectionList,
        { key: '04', value: '04' } as SelectionList,
        { key: '05', value: '05' } as SelectionList,
        { key: '06', value: '06' } as SelectionList,
        { key: '07', value: '07' } as SelectionList,
        { key: '08', value: '08' } as SelectionList,
        { key: '09', value: '09' } as SelectionList,
        { key: '10', value: '10' } as SelectionList,
        { key: '11', value: '11' } as SelectionList,
        { key: '12', value: '12' } as SelectionList
    ] as SelectionList[],
    minutesSecondsSelectionList5: [
        { key: '0', value: '0' } as SelectionList,
        { key: '1', value: '1' } as SelectionList,
        { key: '2', value: '2' } as SelectionList,
        { key: '3', value: '3' } as SelectionList,
        { key: '4', value: '4' } as SelectionList,
        { key: '5', value: '5' } as SelectionList
    ] as SelectionList[],
    minutesSecondsSelectionList10: [
        { key: '0', value: '0' } as SelectionList,
        { key: '1', value: '1' } as SelectionList,
        { key: '2', value: '2' } as SelectionList,
        { key: '3', value: '3' } as SelectionList,
        { key: '4', value: '4' } as SelectionList,
        { key: '5', value: '5' } as SelectionList,
        { key: '6', value: '6' } as SelectionList,
        { key: '7', value: '7' } as SelectionList,
        { key: '8', value: '8' } as SelectionList,
        { key: '9', value: '9' } as SelectionList,
    ] as SelectionList[],
    minutesSecondsSelectionList60: [
        { key: '00', value: '00' } as SelectionList,
        { key: '01', value: '01' } as SelectionList,
        { key: '02', value: '02' } as SelectionList,
        { key: '03', value: '03' } as SelectionList,
        { key: '04', value: '04' } as SelectionList,
        { key: '05', value: '05' } as SelectionList,
        { key: '06', value: '06' } as SelectionList,
        { key: '07', value: '07' } as SelectionList,
        { key: '08', value: '08' } as SelectionList,
        { key: '09', value: '09' } as SelectionList,

        { key: '10', value: '10' } as SelectionList,
        { key: '11', value: '11' } as SelectionList,
        { key: '12', value: '12' } as SelectionList,
        { key: '13', value: '13' } as SelectionList,
        { key: '14', value: '14' } as SelectionList,
        { key: '15', value: '15' } as SelectionList,
        { key: '16', value: '16' } as SelectionList,
        { key: '17', value: '17' } as SelectionList,
        { key: '18', value: '18' } as SelectionList,
        { key: '19', value: '19' } as SelectionList,

        { key: '20', value: '20' } as SelectionList,
        { key: '21', value: '21' } as SelectionList,
        { key: '22', value: '22' } as SelectionList,
        { key: '23', value: '23' } as SelectionList,
        { key: '24', value: '24' } as SelectionList,
        { key: '25', value: '25' } as SelectionList,
        { key: '26', value: '26' } as SelectionList,
        { key: '27', value: '27' } as SelectionList,
        { key: '28', value: '28' } as SelectionList,
        { key: '29', value: '29' } as SelectionList,

        { key: '30', value: '30' } as SelectionList,
        { key: '31', value: '31' } as SelectionList,
        { key: '32', value: '32' } as SelectionList,
        { key: '33', value: '33' } as SelectionList,
        { key: '34', value: '34' } as SelectionList,
        { key: '35', value: '35' } as SelectionList,
        { key: '36', value: '36' } as SelectionList,
        { key: '37', value: '37' } as SelectionList,
        { key: '38', value: '38' } as SelectionList,
        { key: '39', value: '39' } as SelectionList,

        { key: '40', value: '40' } as SelectionList,
        { key: '41', value: '41' } as SelectionList,
        { key: '42', value: '42' } as SelectionList,
        { key: '43', value: '43' } as SelectionList,
        { key: '44', value: '44' } as SelectionList,
        { key: '45', value: '45' } as SelectionList,
        { key: '46', value: '46' } as SelectionList,
        { key: '47', value: '47' } as SelectionList,
        { key: '48', value: '48' } as SelectionList,
        { key: '49', value: '49' } as SelectionList,

        { key: '50', value: '50' } as SelectionList,
        { key: '51', value: '51' } as SelectionList,
        { key: '52', value: '52' } as SelectionList,
        { key: '53', value: '53' } as SelectionList,
        { key: '54', value: '54' } as SelectionList,
        { key: '55', value: '55' } as SelectionList,
        { key: '56', value: '56' } as SelectionList,
        { key: '57', value: '57' } as SelectionList,
        { key: '58', value: '58' } as SelectionList,
        { key: '59', value: '59' } as SelectionList
    ],
    monthMap: {
        '01': 'JAN',
        '02': 'FEB',
        '03': 'MAR',
        '04': 'APR',
        '05': 'MAY',
        '06': 'JUN',
        '07': 'JUL',
        '08': 'AUG',
        '09': 'SEP',
        '10': 'OCT',
        '11': 'NOV',
        '12': 'DEC'
    }
};

interface Props {
    dateTime: Date | null, SetDateTime: any,
    mode?: string, //datetime, date, time
    placeholder?: string
    buttonDisplayFormat?: number
}

const DateTimePicker: React.FC<Props> = ({ dateTime, SetDateTime, mode, placeholder, buttonDisplayFormat }) => {
    //states
    const [shouldShowMenu, SetShouldShowMenu] = useState<boolean>(false);
    //configs
    const [year, SetYear] = useState<string>('');
    const [month, SetMonth] = useState<string>('');
    const [day, SetDay] = useState<string>('');
    const [hours, SetHours] = useState<string>('');
    const [minutes, SetMinutes] = useState<string>('');
    const [seconds, SetSeconds] = useState<string>('');
    const [timeMode, SetTimeMode] = useState<string>(''); //PM or AM
    //refs
    const previousDateTimeRef = useRef<Date | null>(dateTime);
    const previousYearRef = useRef<string>('');
    const previousMonthRef = useRef<string>('');
    const previousDayRef = useRef<string>('');
    const previousHoursRef = useRef<string>('');
    const previousMinutesRef = useRef<string>('');
    const previousSecondsRef = useRef<string>('');

    //watchers
    useEffect(() => {
        //initialize
        InitializeForm();
    }, []);

    //watch for value change update datetime set
    useEffect(() => {
        //adjust hours according to timeMode
        let _hours = parseInt(hours);
        if (timeMode == 'PM' && _hours != 12) {
            _hours += 12;
        } else if(timeMode == 'AM' && _hours == 12) {
            _hours = 24;
        }

        if (year != '' && month != '' && day != '' && hours != '' && minutes != '' && seconds != '' && timeMode != '') {
            SetDateTime(IonDate(year + '-' + month + '-' + day + ' ' + (_hours < 24 ? _hours.toString().padStart(2, '0') : '00') + ':' + minutes + ':' + seconds));
        }

        //reset individuals on datetime select update
        if (previousYearRef.current != year) {
            previousYearRef.current = year;
            ResetFormWithout("year", 'auto');
        } else if (previousMonthRef.current != month) {
            previousMonthRef.current = month;
            ResetFormWithout("year,month,timemode", 'auto');
        } else if (previousDayRef.current != day) {
            previousDayRef.current = day;
            ResetFormWithout("year,month,day,timemode", 'auto');
        } else if (previousHoursRef.current != hours) {
            previousHoursRef.current = hours;
            ResetFormWithout("year,month,day,hours,timemode", 'auto');
        } else if (previousMinutesRef.current != minutes) {
            previousMinutesRef.current = minutes;
            ResetFormWithout("year,month,day,hours,minutes,timemode", 'auto');
        }  else if (previousSecondsRef.current != seconds) {
            previousSecondsRef.current = seconds;
            ResetFormWithout("year,month,day,hours,minutes,seconds,timemode", 'auto');
        }
    }, [year, month, day, hours, minutes, seconds, timeMode/*, timeZoneName*/]);

    //watch for menu close, reset formVars
    useEffect(() => {
        if (!shouldShowMenu)
            ResetFormWithout('', 'empty');
        else {
            InitializeForm();
        }
    }, [shouldShowMenu]);

    //ui functions
    const OnMinutesSecondsSelected = (mode: string, index: number, value: string) => {
        switch (mode) {
            case 'minutes':
                if (index == 0)
                    SetMinutes(value + minutes.substring(1, 2));
                else if (index == 1)
                    SetMinutes(minutes.substring(0, 1) + value);
                break;
            case 'seconds':
                if (index == 0)
                    SetSeconds(value + seconds.substring(1, 2));
                else if (index == 1)
                    SetSeconds(seconds.substring(0, 1) + value);
                break;
        }
    }
    const OnCloseBtnClicked = () => {
        //revert datetime
        SetDateTime(previousDateTimeRef.current);
        SetShouldShowMenu(false);
    }
    const OnSubmitBtnClicked = () => {
        previousDateTimeRef.current = dateTime;
        SetShouldShowMenu(false);
    }
    const OnSelectDateTimeClicked = () => {
        SetShouldShowMenu(true);
        if (dateTime == null)
            SetDateTime(new Date());
    }

    //render functions
    const RenderPickDateMenu = () => {
        const monthBtns = [] as ReactElement[];
        const dayBtns = [] as ReactElement[];
        const maxDays = new Date(parseInt(year), parseInt(month), 0).getDate();

        for (let i = 1; i <= 12; i++) {
            monthBtns.push(
                <button
                    key={'DateTimePicker-month-pick-btn-' + i}
                    className={'DateTimePicker-month-pick-btn ' + (month == i.toString().padStart(2, '0') ? 'selected' : '')}
                    onClick={() => SetMonth(i.toString().padStart(2, '0'))}>
                    {nonstate.monthMap[i.toString().padStart(2, '0') as keyof typeof nonstate.monthMap]}
                </button>
            );
        }

        for (let i = 1; i <= maxDays; i++) {
            dayBtns.push(
                <button
                    key={'DateTimePicker-day-pick-btn-' + i}
                    className={'DateTimePicker-day-pick-btn ' + (day == i.toString().padStart(2, '0') ? 'selected' : '')}
                    onClick={() => SetDay(i.toString().padStart(2, '0'))}>
                    {i.toString().padStart(2, '0')}
                </button>
            );
        }

        return (
            <div className='DateTimePicker-date-pick-menu'>
                <div className='DateTimePicker-year-pick-block'>
                    <button className='DateTimePicker-year-pick-btn' onClick={() => SetYear((parseInt(year) - 1).toString())}><ArrowBackIosIcon /></button>
                    <input className='DateTimePicker-year-pick-in' value={year}
                        onChange={(e: any) => {
                            SetYear(
                                !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ?
                                    parseInt(e.target.value).toString()
                                    :
                                    ''
                            )
                        }}
                        onBlur={(e: any) => {
                            //reset to default if no new date set passed
                            if (e.target.value.replace(/\s/g, '') == '') {
                                SetYear(GetStringValueOfDate(dateTime, 'year'));
                            }
                        }} />
                    <button className='DateTimePicker-year-pick-btn' onClick={() => SetYear((parseInt(year) + 1).toString())}><ArrowForwardIosIcon /></button>
                </div>
                <div className='DateTimePicker-month-pick-block'>
                    {monthBtns}
                </div>
                <div className='DateTimePicker-day-pick-block'>
                    {dayBtns}
                </div>
            </div>
        );
    }
    // const RenderPickTimeMenu = () => {
    //     return (
    //         <div className='DateTimePicker-time-pick-menu'>
    //             <div className='DateTimePicker-time-pick-select ex'>
    //                 <SelectionBox selectionList={nonstate.hoursSelectionList} selectingKey={hours} SetSelectingKey={SetHours} direction='up' />
    //             </div>
    //             <span className='DateTimePicker-time-pick-lbl'>:</span>
    //             <div className='DateTimePicker-time-pick-select'>
    //                 <SelectionBox selectionList={nonstate.minutesSecondsSelectionList5} selectingKey={minutes.substring(0, 1)} SetSelectingKey={(value: string) => OnMinutesSecondsSelected('minutes', 0, value)} direction='up' />
    //             </div>
    //             <div className='DateTimePicker-time-pick-select'>
    //                 <SelectionBox selectionList={nonstate.minutesSecondsSelectionList10} selectingKey={minutes.substring(1, 2)} SetSelectingKey={(value: string) => OnMinutesSecondsSelected('minutes', 1, value)} direction='up' />
    //             </div>
    //             <span className='DateTimePicker-time-pick-lbl'>:</span>
    //             <div className='DateTimePicker-time-pick-select'>
    //                 <SelectionBox selectionList={nonstate.minutesSecondsSelectionList5} selectingKey={seconds.substring(0, 1)} SetSelectingKey={(value: string) => OnMinutesSecondsSelected('seconds', 0, value)} direction='up' />
    //             </div>
    //             <div className='DateTimePicker-time-pick-select'>
    //                 <SelectionBox selectionList={nonstate.minutesSecondsSelectionList10} selectingKey={seconds.substring(1, 2)} SetSelectingKey={(value: string) => OnMinutesSecondsSelected('seconds', 1, value)} direction='up' />
    //             </div>
    //             <button className='DateTimePicker-time-picker-mode-btn' onClick={() => SetTimeMode(timeMode == 'AM' ? 'PM' : 'AM')}>{timeMode}</button>
    //         </div>
    //     );
    // } ---with seconds
    //without seconds
    const RenderPickTimeMenu = () => {
        return (
            <div className='DateTimePicker-time-pick-menu'>
                <div className='DateTimePicker-time-pick-select ex'>
                    <SelectionBox selectionList={nonstate.hoursSelectionList} selectingKey={hours} SetSelectingKey={SetHours} direction='up' />
                </div>
                <span className='DateTimePicker-time-pick-lbl'>:</span>
                <div className='DateTimePicker-time-pick-select ex'>
                    <SelectionBox selectionList={nonstate.minutesSecondsSelectionList60} selectingKey={minutes} SetSelectingKey={SetMinutes} direction='up' />
                </div>
                {/* <div className='DateTimePicker-time-pick-select'>
                    <SelectionBox selectionList={nonstate.minutesSecondsSelectionList10} selectingKey={minutes.substring(1, 2)} SetSelectingKey={(value: string) => OnMinutesSecondsSelected('minutes', 1, value)} direction='up' />
                </div> */}
                <button className='DateTimePicker-time-picker-mode-btn' onClick={() => SetTimeMode(timeMode == 'AM' ? 'PM' : 'AM')}>{timeMode}</button>
            </div>
        );
    }

    //exe functions
    const GetStringValueOfDate = (value: Date | null, mode: string) => {
        if (value != null) {
            let res = IonDateString(value); let hoursString; let hours;

            switch (mode) {
                case 'year':
                    res = res.split(' ')[0].split('-')[0];
                    break;
                case 'month':
                    res = res.split(' ')[0].split('-')[1];
                    break;
                case 'day':
                    res = res.split(' ')[0].split('-')[2];
                    break;
                case 'hours':
                    hoursString = res.split(' ')[1].split(':')[0];
                    hours = parseInt(hoursString);
                    if (hours > 12)
                        hours -= 12;
                    else if (hours == 0)
                        hours = 12;
                    res = hours.toString().padStart(2, '0');
                    break;
                case 'minutes':
                    res = res.split(' ')[1].split(':')[1];
                    break;
                case 'seconds':
                    res = res.split(' ')[1].split(':')[2];
                    break;
                case 'mode':
                    hoursString = res.split(' ')[1].split(':')[0];
                    hours = parseInt(hoursString);
                    if (hours > 12)
                        res = 'PM';
                    else
                        res = 'AM';
                    break;
            }
            return res;
        } else {
            return '';
        }
    }
    const InitializeForm = () => {
        if (year == '') {
            previousYearRef.current = GetStringValueOfDate(dateTime, 'year');
            SetYear(previousYearRef.current);
        }
        if (month == '') {
            previousMonthRef.current = GetStringValueOfDate(dateTime, 'month');
            SetMonth(previousMonthRef.current);
        }
        if (day == '') {
            previousDayRef.current = GetStringValueOfDate(dateTime, 'day');
            SetDay(previousDayRef.current);
        }
        if (hours == '') {
            previousHoursRef.current = GetStringValueOfDate(dateTime, 'hours');
            SetHours(previousHoursRef.current);
        }
        if (minutes == '') {
            previousMinutesRef.current = GetStringValueOfDate(dateTime, 'minutes');
            SetMinutes(previousMinutesRef.current);
        }
        if (seconds == '') {
            previousSecondsRef.current = GetStringValueOfDate(dateTime, 'seconds');
            SetSeconds(previousSecondsRef.current);
        }
        if (timeMode == '') {
            SetTimeMode(GetStringValueOfDate(dateTime, 'mode'));
        }
    }
    const ResetFormWithout = (conditions: string, mode: string) => {
        switch (mode) {
            default:
            case 'auto':
                if (!conditions.includes('year')) {
                    //reset year
                    previousYearRef.current = '0000';
                }
                if (!conditions.includes('month')) {
                    //reset month
                    previousMonthRef.current = '01';
                }
                if (!conditions.includes('day')) {
                    //reset day
                    previousDayRef.current = '01';
                }
                if (!conditions.includes('hours')) {
                    //reset hours
                    previousHoursRef.current = '12';
                }
                if (!conditions.includes('minutes')) {
                    //reset minutes
                    previousMinutesRef.current = '00';
                }
                if (!conditions.includes('seconds')) {
                    //reset seconds
                    previousSecondsRef.current = '00';
                }
                break;
            case 'empty':
                if (!conditions.includes('year')) {
                    //reset year
                    previousYearRef.current = '';
                }
                if (!conditions.includes('month')) {
                    //reset month
                    previousMonthRef.current = '';
                }
                if (!conditions.includes('day')) {
                    //reset day
                    previousDayRef.current = '';
                }
                if (!conditions.includes('hours')) {
                    //reset hours
                    previousHoursRef.current = '';
                }
                if (!conditions.includes('minutes')) {
                    //reset minutes
                    previousMinutesRef.current = '';
                }
                if (!conditions.includes('seconds')) {
                    //reset seconds
                    previousSecondsRef.current = '';
                }
                break;
        }
        SetYear(previousYearRef.current);
        SetMonth(previousMonthRef.current);
        SetDay(previousDayRef.current);
        SetHours(previousHoursRef.current);
        SetMinutes(previousMinutesRef.current);
        SetSeconds(previousSecondsRef.current);

        if(!conditions.includes('timemode')) {
            // SetTimeMode('AM');
        }
    }

    return (
        <div className='DateTimePicker'>
            <button className='DateTimePicker-select-btn selectBtnStyle ' onClick={() => OnSelectDateTimeClicked()}>
                {
                    dateTime != null ?
                        (
                            buttonDisplayFormat != undefined && IsIonDateFormat(buttonDisplayFormat) ?
                            (
                                IonDateString(dateTime, buttonDisplayFormat)
                            )
                            :
                            (
                                mode == undefined || mode == 'datetime' ?
                                IonDateString(dateTime, IonDateFormat.LONG_DATE_TIME)
                                :
                                IonDateString(dateTime, IonDateFormat.LONG_DATE)
                            )
                        )
                        :
                        (placeholder == undefined ? 'Select date and time' : placeholder)
                }
            </button>
            <div className={'DateTimePicker-menu-blockscreen ' + (shouldShowMenu ? 'show' : 'hide')} />
            <div className={'DateTimePicker-menu ' + (shouldShowMenu ? 'show' : 'hide')}>
                {
                    mode == undefined || mode == 'datetime' || mode == 'date' ?
                        RenderPickDateMenu()
                        :
                        null
                }
                {
                    mode == undefined || mode == 'datetime' ?
                        RenderPickTimeMenu()
                        :
                        null
                }
                <button className='DateTimePicker-menu-close-btn' onClick={() => OnCloseBtnClicked()}><CloseIcon /></button>
                <button className='DateTimePicker-menu-submit-btn' onClick={() => OnSubmitBtnClicked()}>Done</button>
            </div>
        </div>
    );
}
export default DateTimePicker;